import { useEffect } from 'react';
import { Background, ReactFlow } from '@xyflow/react';
import { X } from 'lucide-react';
import type { SharedFlowSnapshot } from './realtimeFlow';
import { getNodeTypes } from './nodeRegistry';
import { FlowDisplayLanguageProvider } from './displayLanguage';
import type { FlowDisplayLanguage } from './displayLanguage';

const nodeTypes = getNodeTypes();

type FlowPreviewOverlayProps = {
  snapshot: SharedFlowSnapshot;
  displayLanguage: FlowDisplayLanguage;
  onClose: () => void;
};

export function FlowPreviewOverlay({ snapshot, displayLanguage, onClose }: FlowPreviewOverlayProps) {
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [onClose]);

  return (
    <div className="flow-preview-overlay" role="dialog" aria-modal="true" aria-label="フローチャートプレビュー">
      <FlowDisplayLanguageProvider value={displayLanguage}>
        <ReactFlow
          nodes={snapshot.nodes}
          edges={snapshot.edges}
          nodeTypes={nodeTypes}
          nodesDraggable={false}
          nodesConnectable={false}
          elementsSelectable={false}
          deleteKeyCode={null}
          panOnDrag
          zoomOnDoubleClick={false}
          fitView
          fitViewOptions={{ padding: 0.2 }}
          className="flow-strong-connectors"
        >
          <Background color="#9aa8ba" />
        </ReactFlow>
      </FlowDisplayLanguageProvider>
      <button
        type="button"
        className="flow-preview-overlay__close"
        onClick={onClose}
        aria-label="フローチャートプレビューを閉じる"
        title="プレビューを閉じる"
      >
        <X aria-hidden="true" />
      </button>
    </div>
  );
}
